<div mat-dialog-content>
    <div class="label-container-button">
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <p class="title">Listado de Campos</p>
    <form [formGroup]="form" class="label-form">
        <div class="label-group">
            <label class="primaryColor">Campo</label>
            <input formControlName="field" type="text" class="form-control" placeholder="Campo">
        </div>
        <div *ngIf="editing !=0">
            <div class="label-box">
                <label class="primaryColor">Activo</label>
                <div class="label-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                    <div class="label-checkbox">
                        <input id="check" formControlName="active" type="checkbox">
                        <label class="label-label" for="check">
                            <mat-icon>done</mat-icon>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="label-group">
            <button mat-mini-fab class="green " matTooltip="Guardar" matTooltipPosition="right"
                matTooltipClass="tooltip" (click)="onClick()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </form>
    <table class="label-table" mat-table [dataSource]="dataSource" #table>
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let item">
                <button *ngIf="item.id === editing" mat-icon-button matTooltip="Cerrar Edicion"
                    matTooltipPosition="above" matTooltipClass="tooltip" (click)="closeEditing()">
                    <mat-icon class="ligthColor">close</mat-icon>
                </button>
            </td>
        </ng-container>
        <ng-container matColumnDef="field">
            <th mat-header-cell *matHeaderCellDef>Campo</th>
            <td mat-cell *matCellDef="let item">{{item.field}}</td>
        </ng-container>
        <ng-container matColumnDef="active">
            <th mat-header-cell *matHeaderCellDef>Activo</th>
            <td mat-cell *matCellDef="let item">
                <mat-icon *ngIf="item.active" class="green-color">done</mat-icon>
                <mat-icon *ngIf="!item.active" class="red-color">clear</mat-icon>
            </td>
        </ng-container>
        <ng-container matColumnDef="Acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let item">
                <button mat-icon-button matTooltip="Eliminar" matTooltipPosition="above" matTooltipClass="tooltip"
                    (click)="delete(item.id)">
                    <mat-icon class="red-color">delete</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Editar" matTooltipPosition="above" matTooltipClass="tooltip"
                    (click)="edit(item.id,item.field,item.active)">
                    <mat-icon class="blue-color">create</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Mas" matTooltipPosition="above" matTooltipClass="tooltip" [matMenuTriggerFor]="menuUser">
                    <mat-icon class="orange-color">more_vert</mat-icon>
                </button>
                <mat-menu #menuUser="matMenu" xPosition="before">
                    <button mat-menu-item  (click)="rule(item.id)">
                       <mat-icon class="load-color-menu">straighten</mat-icon>
                       <span>Reglas</span>
                   </button>
               </mat-menu>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
</div>